import { render, staticRenderFns } from "./JournalEntryDetailContent.vue?vue&type=template&id=ddd02de2&"
import script from "./JournalEntryDetailContent.vue?vue&type=script&lang=js&"
export * from "./JournalEntryDetailContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports